import * as React from "react";
import { Link } from "gatsby";

// Import layout
import Layout from "../layouts/main";

// Import components
import SEO from "../components/seo";

// Shopify stuff
import {
  useCart,
  useCartItems,
  useCheckoutUrl,
  useRemoveItemsFromCart,
} from "gatsby-theme-shopify-manager";

// Import styles
import "./styles/bag.scss";

// Import assets
import image from "../assets/images/og-image.jpg";

// Import icons
import { AiOutlineClose } from "react-icons/ai";

// Import bootstrap
import { Button, Card, Col, Container, Row } from "react-bootstrap";

// markup
const BagPage = () => {
  const cart = useCart();
  const cartItems = useCartItems();
  const checkoutUrl = useCheckoutUrl();
  const removeItemsFromCart = useRemoveItemsFromCart();

  async function removeFromCart() {
    if (cartItems.length < 1) {
      return;
    }
    const variantId = cartItems[0].variant.id;

    try {
      await removeItemsFromCart([variantId]);
    } catch {
      alert("There was a problem removing that item from your cart.");
    }
  }

  console.log(cartItems);

  // Checkout button
  let checkoutButton = "";
  if (checkoutUrl === null) {
    checkoutButton = (
      <div className="no-click">
        <Button className="disabled" variant="primary" disabled>
          Checkout
        </Button>
      </div>
    );
  }
  if (cartItems.length === 0) {
    checkoutButton = (
      <div className="no-click">
        <Button className="disabled" variant="primary" disabled>
          Checkout
        </Button>
      </div>
    );
  } else {
    checkoutButton = (
      <a href={checkoutUrl} target="_blank" rel="noopener noreferrer">
        <Button variant="primary">Checkout</Button>
      </a>
    );
  }
  // Cart contents
  let cartContents = "";
  if (cartItems.length === 0) {
    cartContents = (
      <>
        <Col className="cart-items" xs={12} md={8}>
          <p className="talk">
            Your bag is empty!
            <br />
            <Link className="link" to="/#the-shop">
              Go shopping &rarr;
            </Link>
          </p>
        </Col>
        <Col className="cart-total" xs={12} md={4}>
          <p className="talk">
            Total: <strong>$0.00</strong>
          </p>
          {checkoutButton}
        </Col>
      </>
    );
  } else {
    cartContents = (
      <>
        <Col className="cart-items" xs={12} md={8}>
          {cartItems.map((lineItem) => (
            <div className="cart-item" key={lineItem.title}>
              <img
                src={lineItem.variant.image.src}
                alt={`${lineItem.title} product shot`}
              />
              <div className="cart-item-details">
                <p className="talk">
                  ${Number(lineItem.variant.priceV2.amount).toFixed(2)} - 20%
                </p>
                <h3 className="yell">{lineItem.title}</h3>
                <a className="link" variant="primary" onClick={removeFromCart}>
                  &#10005; Remove this item
                </a>
              </div>
            </div>
          ))}
        </Col>
        <Col className="cart-total" xs={12} md={4}>
          <p className="talk">
            Total: <strong>${cart.totalPrice}</strong>
          </p>
          {checkoutButton}
        </Col>
      </>
    );
  }

  return (
    <Layout>
      <SEO
        title="Your Bag | The Lisa Mae"
        description="Contact Lisa Mae Osborne."
        image={`https://thelisamae.netlify.com${image}`}
      />
      <Container className="cart-page">
        <h1 className="shout">What's in your bag:</h1>
        {cartContents}
      </Container>
    </Layout>
  );
};

export default BagPage;
